import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useStreams(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getStreams() {
    return privateFetch.get(`/v1/admin/streams${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['streamsApi', { data }], getStreams, { enabled, keepPreviousData: true });
}

export default useStreams;
